//#region IMPORTS
import { Listbox, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Fragment } from "react";
import classNames from "../../helpers/classNames";
//#endregion

//#region INTERFACE
interface Props {
  parcels: string[];
}
//#endregion

export default function InstoreOrdersTableRowTrackAndTraceMenu({
  parcels,
}: Props) {
  //#region RENDER
  return (
    <Listbox>
      {({ open }) => (
        <div className="relative">
          <div
            className={classNames(
              parcels.length > 1 ? "divide-x divide-white" : "",
              "inline-flex outline-hidden w-28 h-6"
            )}
          >
            <div
              className={classNames(
                parcels.length > 1
                  ? "rounded-l-full flex-1 min-w-0"
                  : "rounded-full justify-center hover:bg-emerald-700 w-full",
                "inline-flex items-center gap-x-1 text-[10px] font-bold tracking-tighter bg-emerald-500 px-2 py-0.5 text-white whitespace-nowrap"
              )}
            >
              {parcels.length > 1 ? (
                <span>TRACK &amp; TRACE</span>
              ) : (
                <a href={parcels.join("")} target="_blank" rel="noreferrer">
                  TRACK &amp; TRACE
                </a>
              )}
            </div>
            {parcels.length > 1 ? (
              <Listbox.Button className="inline-flex items-center rounded-l-none rounded-r-full bg-emerald-500 p-1 hover:bg-emerald-700 focus-visible:outline-2 focus-visible:outline-emerald-400">
                <ChevronDownIcon className="w-4 h-4 text-white" />
              </Listbox.Button>
            ) : null}
          </div>

          <Transition
            show={open}
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute right-0 z-10 mt-1 max-h-60 min-w-max overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-xs">
              {parcels.map((parcel, index) => (
                <Listbox.Option
                  key={index}
                  className={({ active }) =>
                    classNames(
                      active ? "bg-emerald-50" : "",
                      "relative cursor-default select-none py-2 pl-3 pr-4 text-gray-900"
                    )
                  }
                  value={parcel}
                >
                  {({ active }) => (
                    <a
                      href={parcel}
                      target="_blank"
                      rel="noreferrer"
                      className={classNames(
                        active ? "font-bold" : "font-normal",
                        "block whitespace-nowrap"
                      )}
                    >
                      {`Track parcel ${index + 1}`}
                    </a>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      )}
    </Listbox>
  );
  //#endregion
}
